import { render } from "./DecorateModalTitle.vue?vue&type=template&id=e3d43ef2&ts=true"
import script from "./DecorateModalTitle.vue?vue&type=script&lang=ts"
export * from "./DecorateModalTitle.vue?vue&type=script&lang=ts"

import "./DecorateModalTitle.vue?vue&type=style&index=0&id=e3d43ef2&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__